<template>
  <module-tab name="已结算" enable-flex @mounted="tabHandle" @activated="$refs.table.update()">
    <m-search ref="search" @search="searchHandle">
      <m-search-item label="订单编号">
        <c-input name="order_number"></c-input>
      </m-search-item>
      <m-search-item label="费用名称">
        <c-input name="fee_name"></c-input>
      </m-search-item>
      <m-search-item label="结算批次">
        <c-input name="batch_number"></c-input>
      </m-search-item>
      <m-search-item label="生成时间" colspan="2">
        <c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
      </m-search-item>
      <m-search-item label="结算时间" colspan="2">
        <c-datetime start-name="settled_start_date" end-name="settled_end_date" range></c-datetime>
      </m-search-item>
    </m-search>
    <m-operate>
        <c-button color="m" hollow @click="syncExport()">导出</c-button>
    </m-operate>
    <c-table ref="table" height="grow">
      <c-table-column
          label="订单编号"
          width="130"
          name="order_number"
      >
      </c-table-column>

      <c-table-column
          label="费用名称"
          width="100"
          name="fee_name"
      >
      </c-table-column>

      <c-table-column
          label="商品数量"
          width="80"
          name="settled_count"
      >
      </c-table-column>

      <c-table-column
          label="金额"
          width="100"
      >
        <template #default="{data}">
          ￥ {{data.settled_amount}}
        </template>
      </c-table-column>

      <c-table-column
          label="生成时间"
          width="120"
          name="create_date"
      ></c-table-column>

      <c-table-column
          label="结算批次"
          width="100"
          name="batch_number"
      ></c-table-column>

      <c-table-column
          label="结算时间"
          width="120"
          name="settled_date"
      ></c-table-column>

      <c-table-column
          type="button"
          label="操作"
          width="100"
      >
        <template #default="{data}">
          <c-table-button v-if="data.fee_code == 1000" @click="detail(data)">查看明细</c-table-button>
        </template>
      </c-table-column>
    </c-table>

    <c-dialog ref="detailDialog" title="结算明细" width="1000" :button="false">
      <c-table ref="detailTable" height="500" >
        <c-table-column
            label="商品信息"
            width="300"
        >
          <template #default="{data}">
            <div class="flex-center-cross">
              <c-file media :src="data.product_img_url" style="margin-right: 18px;"></c-file>
              <p>{{data.product_name}}<br/>{{data.product_sku_spec}}</p>
            </div>
          </template>
        </c-table-column>

        <c-table-column
            label="商品单价"
            width="200"
        >
          <template #default="{data}">
            ￥ {{data.product_unit_price}}
              <p style="color:brown;" v-if="orderType == 7 && data.custom_unit_price && data.custom_unit_price>0">(含定制费：￥ {{data.custom_unit_price}})</p>
          </template>
        </c-table-column>

        <c-table-column
            label="结算数量"
            width="130"
        >
          <template #default="{data}">
            x {{data.settled_count}}
          </template>
        </c-table-column>

        <c-table-column
              label="服务费"
              width="80"
        >
          <template #default="{data}">
                  <span style="color:red;">￥ {{data.settled_service_money}}</span>
          </template>
        </c-table-column>

        <c-table-column
              label="结算金额"
              width="130"
        >
              <template #default="{data}">
                  ￥ {{data.settled_money}}
              </template>
          </c-table-column>
      </c-table>
    </c-dialog>
  </module-tab>
</template>

<script>
export default {
  data() {
    return {
        workType:22,
        searchParams:{},
        orderType:0, //订单类型 7=定制单
        settle_state:2  //1=待结算  2=已结算
    }
  },

  methods: {
    tabHandle() {
      this.$refs.search.search();
    },

    searchHandle(data) {
      this.searchParams = Object.assign(data, {
            settle_state: this.settle_state
      });
      this.$refs.table.load({
        url: '/buss/settlement/stationed/list',
        data:this.searchParams
      });
    },

    detail(data) {
       this.orderType = data.order_type;
       this.$refs.detailTable.load({
            url: '/buss/settlement/detail/list',
            data: {
              order_number: data.order_number,
              batch_number: data.batch_number,
              settle_state: this.settle_state
            }
      });
      this.$refs.detailDialog.open();
    },
    /**同步导出数据**/
    syncExport(){
          this.request({
              url: '/export/url',
              data: Object.assign({
                  work_type: this.workType //业务类型
              },this.searchParams),
              success: data => {
                  this.download({
                      fileName: data.filename,
                      url: data.url,
                      loading: {
                          message: '数据文件生成中...'
                      }
                  })
              }
          });
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
